import { useState } from 'react';

import { usePlayerInstance } from '@/scenarios/legacy-player/lib/contexts/instance';
import { useInstanceEffect } from '@/scenarios/legacy-player/hooks/useInstanceEffect';

import { TextTrack } from '../types/instance';

export const useCurrentTextTrack = () => {
    const instance = usePlayerInstance();
    const [currentTextTrack, setCurrentTextTrack] = useState<TextTrack | undefined>(
        () => instance?.textTrack
    );

    useInstanceEffect((instance) => instance.onCurrentTextTrackChange(setCurrentTextTrack));

    return currentTextTrack;
};
